import { HttpContextToken } from '@angular/common/http';

/**
 * Contador de reintentos HTTP por petición (NIF-646).
 * Vive en HttpContext: no se envía al backend; evita bucles infinitos en el interceptor.
 */
export const STORAGE_RETRY_COUNT = new HttpContextToken<number>(() => 0);

/** Reintentos adicionales tras el intento original (3 peticiones HTTP en total). */
export const MAX_STORAGE_HTTP_RETRIES = 2;
